import { Divider } from '@mui/material';
import TextField from '@mui/material/TextField';
import { MemreFlexBox } from 'components/core';
import { useAuthoringContext } from 'pages/authoring/AuthoringContext';
import AttachInstructionalItem from '../components/AttachInstructionalItem';
import { useState } from 'react';
import { FreeResponses } from 'services/useItem.service/interactions';

export default function FreeResponsesElement() {
  const freeResponse = useAuthoringContext()?.item as FreeResponses;
  const [questionText, setQuestionText] = useState(freeResponse.question.text);

  return (
    <MemreFlexBox
      direction="column"
      gap={2}
      sx={{
        p: 2,
        pl: 0,
        width: '100%',
      }}
    >
      <MemreFlexBox direction="row" gap={2}>
        <TextField
          label="Question Text"
          variant="outlined"
          sx={{ flex: 1 }}
          value={questionText}
          onBlur={() => freeResponse.question.update(questionText)}
          onChange={(e) => setQuestionText(e.target.value)}
        />
      </MemreFlexBox>

      <Divider sx={{ width: '100%', m: 0.5, mt: 2 }} />
      
      {freeResponse?.id && (
        <AttachInstructionalItem 
          itemId={freeResponse.id}
        />
      )}
    </MemreFlexBox>
  );
}
